import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { MessageService } from 'primeng/api';
import { HelpersService } from 'src/app/services/helpers.service';
import { InvoiceService } from 'src/app/services/invoice.service';
import { PosIntegrationService } from 'src/app/services/pos-integration.service';
import {WorkshopJobcardInitiateRefundComponent} from './workshop-jobcard-initiate-refund/workshop-jobcard-initiate-refund.component'
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-workshop-jobcard-quote-payments',
  templateUrl: './workshop-jobcard-quote-payments.component.html',
  styleUrls: ['./workshop-jobcard-quote-payments.component.scss']
})
export class WorkshopJobcardQuotePaymentsComponent {

  @Input() jobcard;

  public countryData: any = {};
  public paymentHistory: any = [];
  public partner: any = {};

  public busySyncing: boolean = false;
  public busyLoading: boolean = false;
  public hasRefund: boolean = false;
  public canRefund: boolean = false;

  constructor(
    private invoiceService: InvoiceService,
    private helpersService: HelpersService,
    private posIntegrationService: PosIntegrationService,
    public messageService: MessageService,
    private translate: TranslateService,
    private modalService: NgbModal
  ) { }

  ngOnInit() {
    this.partner = this.helpersService.getPartnerData();
    this.countryData = this.helpersService.getCountryData();
    this.getPayments();

  }

  getPayments() {
    this.busyLoading = true;
    this.invoiceService
      .getPaymentHistory(this.jobcard.partnerID, this.jobcard.id)
      .subscribe(
        (res) => {
          this.paymentHistory = res;
          this.busyLoading = false;
          var paymentsTotal = 0;
          var refundsTotal = 0;
          this.paymentHistory.filter((x: any) => { return x.paymentMethod === "STRIPE" }).forEach(payment => {
            paymentsTotal += payment.amountPaid;
            if (payment.refunds && payment.refunds.length > 0) {
              this.hasRefund = true;
              refundsTotal += payment.refunds.map((x: any) => { return x.amountRefunded }).reduce((acc, num) => acc + num, 0);
            }
            if (payment.paymentMethod === "STRIPE") {
              this.canRefund = true;
            }
          });
          if (this.canRefund && refundsTotal >= paymentsTotal) {
            this.canRefund = false;
          }
        },
        (err) => {
          this.busyLoading = false;
        },
      );
  }

  syncPayments() {
    this.busySyncing = true;
    if (this.helpersService.getPartnerData().POSSystemID <= 10) {
      this.posIntegrationService.syncWorkshopPOSPayments(this.jobcard.partnerID, this.jobcard.id).subscribe(res => {
        //this.reloadReservation.emit({});      
        this.getPayments();
        this.busySyncing = false;
      }, err => {
        this.busySyncing = false;
      });
    } else {
      this.posIntegrationService.syncNewWorkshopPOSPayments(this.jobcard.partnerID, this.jobcard.quote.id).subscribe(res => {
        //this.reloadReservation.emit({});      
        this.getPayments();
        this.busySyncing = false;
      }, err => {
        this.busySyncing = false;
      });
    }
  }

  canHandlePayments() {
    return this.partner.POSSystemID === 3 || this.partner.POSSystemID === 6 || this.partner.POSSystemID === 9 || this.partner.POSSystemID === 12 || this.partner.POSSystemID === 17 || this.partner.POSSystemID === 19;
  }

  noPOSSolution() {
    return this.partner.POSSystemID <= 0;
  }

  initiateRefund() {
        const modalRef = this.modalService.open(WorkshopJobcardInitiateRefundComponent, {
          backdrop: true,
          backdropClass: 'jobcard-modal-popup-backdrop',
          windowClass: 'jobcard-modal-popup-window',
          size: 'md'
        });
    
        modalRef.componentInstance.payments = this.paymentHistory;
        modalRef.componentInstance.partner = this.partner;
        modalRef.componentInstance.countryData = this.countryData;
        modalRef.componentInstance.refundComplete.subscribe(() => {
          this.refundComplete();
        });
    
        modalRef.result.then(
          (result) => {
            
          },
          (onrejected) => {
            console.log('Modal dismissed:', onrejected);
          },
        );
  }

  refundComplete() {
    
    this.getPayments();
    this.messageService.add({
      key: 'payment-toast',
      life: 5000,
      detail: this.translate.instant(
        'bikeshop.modal.initiate_refund.refund_complete'
      ),
    });
  }
}
